module.exports = {
          srcSet: __webpack_public_path__ + "27d5bd8bf037cf45a073ea18b1a1bce5-90.png"+" 90w",
          images:[ {path: __webpack_public_path__ + "27d5bd8bf037cf45a073ea18b1a1bce5-90.png",width: 90,height: 108}],
          src: __webpack_public_path__ + "27d5bd8bf037cf45a073ea18b1a1bce5-90.png",
          toString:function(){return __webpack_public_path__ + "27d5bd8bf037cf45a073ea18b1a1bce5-90.png"},
          
          width: 90,
          height: 108
        }